module.exports = __webpack_public_path__ + "static/img/6.acf685a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/6.png
// module id = kTFH
// module chunks = 0